import { gql } from '@apollo/client';

export const CREATE_APPOINTMENT = gql`
mutation CreateAppointmentMutation($date: String!, $storeCode: String!, $status: StatusInput!, $requestedTime: RequestedTimeInput!) {
    createAppointmentByStoreCode(
      appointment: {
        type: "Appointment",
        date: $date,
        storeCode: $storeCode,
        status: $status,
        requestedTime: $requestedTime,
      }
    ) {
      id
    }
  }
`;
